import styled from "styled-components";

export const Container = styled.section`
	background: #ffffff;
	border: 1px solid #dcdfe6;
	border-radius: 10px;
	padding: 21px 21px 18px;
	width: 100%;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const Title = styled.h2`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #000e4b;
	margin: 0;
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const BadgeSoon = styled.span`
	background: #dff2ff;
	color: #0076a8;
	border-radius: 100px;
	padding: 4px 8px;
	font-size: 8px;
	font-weight: 800;
	font-family: "NotoSans-Bold", sans-serif;
	line-height: 1;
`;

export const MetaText = styled.div`
	color: #797d8d;
	font-size: 12px;
	margin: 8px 0 15px;
	font-family: "NotoSans-Regular", sans-serif;
`;

export const Description = styled.p`
	color: #000e4b80;
	font-size: 12px;
	margin: 0 0 17px;
	font-family: "NotoSans-Regular", sans-serif;
`;

export const EarlyAccessButton = styled.button<{ isRequested?: boolean }>`
	width: 100%;
	height: 41px;
	border: 0;
	border-radius: 12px;
	padding: 0 15px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 11px;
	font-weight: 800;
	font-family: "NotoSans-Bold", sans-serif;
	color: #ffffff;
	background-color: ${({ isRequested }) =>
		isRequested ? "#00A377" : "#000e4b"};
	cursor: ${({ isRequested }) => (isRequested ? "default" : "pointer")};
	pointer-events: ${({ isRequested }) => (isRequested ? "none" : "auto")};
	transition: background-color 0.22s ease;

	&:hover {
		background-color: ${({ isRequested }) =>
			isRequested ? "#00A377" : "#10246c"};
	}

	svg {
		transition: transform 0.2s;
	}

	&:hover svg {
		transform: translateX(2px);
	}
`;
